/* src/app/views/blog/blog-detail/blog-detail.component.css */
/*# sourceMappingURL=blog-detail.component.css.map */
